import AppTypes from 'st-app/Types/AppTypes';
import { AppService } from 'st-common/Clients/ClientsTypes';
import { ClientsSharedTypes } from './ClientsSharedTypes';

const Types = {
    ...AppTypes,
    Clients: {
        ApiClients: {
            ...ClientsSharedTypes.ApiClients,
        },
        Services: {
            ...ClientsSharedTypes.Services
        }
    }
}

export { AppService, Types }
